import React, { useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import { connect } from "react-redux";
import * as actions from "../../store/actions";

import SearchBarCustom from "../../components/CourseList/SearchBarCustom/SearchBarCustom";
import SortButton from "../../components/CourseList/SortButton/SortButton";
import FilterButton from "../../components/CourseList/FilterButton/FilterButton";
import GroupButton from "../../components/CourseList/GroupButton/GroupButton";
import CourseCardItemE from "./CourseCardE";
import CourseCardItemP from "./CourseCardP";
import Spinner from "../../components/UI/Spinner/Spinner";
// import DataLength from "../../components/DataDisplay/DataLength";
import DataLengthE from "./DataLengthE";
import DataLengthP from "./DataLengthP";

const Courses = (props) => {
  let { courseList } = props;

  const { loading } = props;
  const { onfetchCourses } = props;
  const { lang } = props;

  const [courseType, setCourseType] = useState("all");
  const [sortBy, setSortBy] = useState("id");
  const [group, setGroup] = useState("1");
  const [keyWord, setKeyWord] = useState(null);

  const localLang = JSON.parse(localStorage.getItem("lang"));

  let isEng = lang;

  if (!lang) {
    isEng = localLang;
  }

  useEffect(() => {
    onfetchCourses(courseType, group, keyWord);
  }, [onfetchCourses, courseType, group, keyWord]);

  const handleChangeKeyWord = (word) => {
    setCourseType("all");
    setTimeout(() => {
      setKeyWord(word);
    }, 1500);
  };

  switch (sortBy) {
    case "date":
      courseList = courseList.slice(0);
      courseList.sort(function (a, b) {
        var x = parseInt(a.ngayTao.split("/"));
        var y = parseInt(b.ngayTao.split("/"));
        return x - y;
      });
      break;
    case "a-z":
      courseList = courseList.slice(0);
      courseList.sort(function (a, b) {
        var x = a.tenKhoaHoc.toLowerCase();
        var y = b.tenKhoaHoc.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
      break;
    case "z-a":
      courseList = courseList.slice(0);
      courseList.sort(function (a, b) {
        var y = a.tenKhoaHoc.toLowerCase();
        var x = b.tenKhoaHoc.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
      break;

    default:
      break;
  }

  let courseListRender = <Spinner />;
  if (!loading && courseList.length > 0) {
    courseListRender = courseList.map((course, index) => (
      <Grid item key={index}>
        {/* <CourseCardItemE course={course} /> */}
        {isEng ? (
          <CourseCardItemP course={course} />
        ) : (
          <CourseCardItemE course={course} />
        )}
      </Grid>
    ));
  }

  return (
    <Box>
      <Box
        pt={5}
        mb={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
      >
        <Box m={1}>
          <SortButton
            sortBy={sortBy}
            onChangeSortBy={(sort) => setSortBy(sort)}
          />
        </Box>
        <Box m={1}>
          <FilterButton
            lang = {lang}
            courseType={courseType}
            onChangeIndex={(code) => setCourseType(code)}
          />
        </Box>
        <Box m={1}>
          <GroupButton
            lang = {lang}
            group={group}
            onChangeGroup={(choosen) => setGroup(choosen)}
          />
        </Box>
        <Box m={1}>
          <SearchBarCustom onChangeKeyWord={handleChangeKeyWord} />
        </Box>
      </Box>

      {courseList && courseList.length ? (
        <Box display="flex" justifyContent="center" m={3}>
          {/* <DataLengthE items={courseList.length} type={"courses"} /> */}
          {isEng ? (
          <DataLengthP items={courseList.length} type={"courses"} />
        ) : (
          <DataLengthE items={courseList.length} type={"دوره"} />
        )}
        </Box>
      ) : null}

      <Grid container spacing={2} justify="center">
        {courseListRender}
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    courseList: state.courses.courseList,
    loading: state.courses.loading,
    lang: state.ui.lang,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onfetchCourses: (courseType, group, keyWord) =>
      dispatch(actions.fetchCourses(courseType, group, keyWord)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Courses);
